module.exports = __webpack_public_path__ + "assets/img/home-prc-light.361cf18e.png";